import { twMerge } from "tailwind-merge";
import { BadgeBase, type BadgeBaseProps } from "@core/ui";

export type Props = BadgeBaseProps;

/**
 * Styled badge component wrapping BadgeBase.
 * Displays inline labels, tags, or status indicators.
 */
export function Badge({ children, className, ...props }: Props) {
  return (
    <BadgeBase
      className={twMerge(
        "inline-flex items-center justify-center px-1.5 py-0.5 rounded-full border border-brand-800 text-brand-800 text-xs font-medium shadow-sm whitespace-nowrap",
        className
      )}
      {...props}
    >
      {children}
    </BadgeBase>
  );
}

export default Badge;
